import Character from "../Character";
import TurnAction from "./TurnAction";

export default class MoveTurnAction extends TurnAction {
    /**
     */
    constructor() {
        super();
    }

    /**
     * @override
     * @param {Character} character The character making the turn action.
     * @param {number} frameTimeRatio The time frame ratio.
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    performAction(character, frameTimeRatio, turnStart) {
     
        const position = character.position;

        if (position.pathPlan.length > 0) {
            character.followPathPlan(frameTimeRatio, turnStart);
        }

        if (position.pathPlan.length === 0) {
            // Do not reset the target here.
            character.position.resetPathPlan();
            character.turnAction = null;
        }
    }

    /**
     * Returns true if this turn action will move the character and affect the path plan.
     * @override
     * @returns {boolean}
     */
    isMovementAction() {
        return true;
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'MoveTurnAction';
    }
}